import '../css/Dashboardpage.css';
import axios from 'axios';
import ApiConfig from '../utils/ApiConfig';
import ApiResponse from '../model/response/ApiResponse';
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Oval } from "react-loader-spinner";

function Reportcount({ onClose }) {

    const rawVal = localStorage.getItem('loginVal');
    let loginVal = rawVal ? JSON.parse(rawVal) : null;
    const token = loginVal?.token;

    const [reportCount, setReportCount] = useState([]);
    const [reportbyUser, setReportbyUser] = useState([]);
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [showDetails, setShowDetails] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    function showToast(message) {
        toast.success(message, { autoClose: 2000 });
    }

    function showToastFailed(message) {
        toast.error(message, { autoClose: 2000 });
    }

    useEffect(() => {
        reportCountAPICall();
    }, []);

    function reportCountAPICall() {
        // setIsLoading(true);
        axios.get(
            ApiConfig.getUrl("User/reportCount"),
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            }
        )
            .then(response => {
                const api = ApiResponse.fromJson(response.data);

                if (api.statusCode == 200) {
                    setReportCount(api.response);
                    setIsLoading(false);
                    showToast(api.message);
                }
            })
            .catch(() => {
                showToastFailed("No Report Users");
                setIsLoading(false);
            });
    }


    function reportbyUserAPICall(report_OpponentId) {
        setIsLoading(true);
        axios.get(

            ApiConfig.getUrl("User/reportByUser"),
            {
                params: {
                    Report_OpponentId: report_OpponentId
                },
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            }
        )
            .then(response => {
                const api = ApiResponse.fromJson(response.data);

                if (api.statusCode == 200) {
                    setReportbyUser(api.response);
                    setShowDetails(true);
                    setIsLoading(false);
                    showToast(api.message);
                }
            })
            .catch(() => {
                showToastFailed("No Report Users");
                setIsLoading(false);
            });
    }


     const disableRightClick = (e) => {
    e.preventDefault();
  };


    return (
        <div  onContextMenu={disableRightClick}>
            {isLoading && (
                <div className="loader-overlay">
                    <Oval
                        height={60}
                        width={60}
                        color="#ffffff"
                        secondaryColor="#cccccc"
                        strokeWidth={4}
                        visible={true}
                    />
                </div>
            )}
            <div className='dashboard_fullpage w-100' >
            <div className=" register_design w-100 p-3 h-100" style={{ backgroundColor: "white" }}>

                <div className="d-flex justify-content-between align-items-center p-3">
                    <h5 className="m-0">Report Count</h5>

                    <button
                        className="btn-close"
                        onClick={onClose}
                    ></button>
                </div>

                <hr />
                {!showDetails ? (


                    <table className='table_size p-2 '>
                        <thead >
                            <tr >
                                <th>S.No</th>
                                <th>User ID</th>
                                <th>Name</th>
                                <th>Report Count</th>
                                <th>Status</th>
                               
                               
                               
                            </tr>
                        </thead>
                        <tbody>
                            {reportCount.map((n, index) => (
                                <tr key={n.report_OpponentId} onClick={() => reportbyUserAPICall(n.report_OpponentId)}
                                        style={{ cursor: "pointer" }}>
                                    <td>{index + 1}</td>
                                    <td>IMIT{n.report_OpponentId}</td>
                                    <td
                                         >
                                        {n.name}
                                    </td>
                                    <td>{n.totalCount}</td>
                                     <td>{n.reportStatus}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                ) : (

                    <>
                        <button
                            className="btn btn-info mb-2"
                            onClick={() => {
                                setShowDetails(false);                            
                            }} >
                            ← Back
                        </button>


                        <table className="table_size                                        ">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>User ID</th>
                                    <th>Name</th>
                                    <th>Reason</th>
                                    <th>Reported At</th>
                                </tr>
                            </thead>
                            <tbody>
                                {reportbyUser.map((n, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{n.user_Id}</td>
                                        <td>{n.name}</td>
                                        <td>{n.reports}</td>
                                        <td>{n.reported_at}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </>
                )}

            </div>
            </div>
        </div>
    );
}

export default Reportcount;